export interface LoginFormModel {
  username: string;
  password: string;
}

export enum CompanyType {
  Organizer = 1,
  Manufacturer = 2,
  Auditor = 3,
  Steel = 5,
}

export interface UserInfo {
  userId: string;
  userName: string;
  token: string;
  companyId: string;
}

export interface CompanyInfo {
  companyId: string;
  companyName: string;
  companyType: CompanyType;
  companyLogoURL?: string;
}

export interface UserCompanyInfo extends UserInfo, CompanyInfo {}

//Backend Types
export interface AuthenticationInput extends LoginFormModel {
  captchaResponse?: string;
}

export interface LoginResponse {
  userName: string;
  userCompaniesInfo: UserCompaniesInfoType[];
}
export interface UserTokenObjectType {
  token: string;
  userName: string;
}

export interface UserCompaniesInfoType {
  companyId: string;
  userId: string;
  companyLogoURL: string;
  companyType: CompanyType;
  companyName: string;
  isDemo: boolean;
  tokenObject: UserTokenObjectType;
}
